<template>
    <nav class="breadcrumb flex pb-4 px-0 truncate" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center gap-x-1 flex-wrap">
            <li v-for="(page, index) in pages" :key="page.title" :aria-hidden="index === 0 ? 'hidden' : undefined">
                <div class="flex items-center">
                    <ChevronRightIcon v-if="index !== 0" class="size-2 shrink-0 text-anthrazit-60 mr-1" aria-hidden="true" />
                    <a
                        v-if="page.url"
                        :href="page.url"
                        class="font-medium text-xs hover:underline whitespace-nowrap"
                        :class="page.current ? 'text-black' : 'text-anthrazit-60'"
                        :aria-current="page.current ? 'page' : undefined"
                        >{{ page.title }}</a>
                    <span
                        v-else
                        class="font-medium text-xs whitespace-nowrap"
                        :class="page.current ? 'text-black' : 'text-anthrazit-60'"
                    >{{ page.title }}</span>
                </div>
            </li>
        </ol>
    </nav>
</template>

<script>
import { ChevronRightIcon } from "@heroicons/vue/20/solid"

export default {
    components: {
        ChevronRightIcon,
    },
    props: {
        pages: {
            type: Array,
            required: true,
        }
    },
}
</script>
